import { API, Auth } from 'aws-amplify';
import * as _ from 'lodash';

import { showModal, hideModal } from './'

import {
    FETCH_TASK_DETAILS,
    FETCH_TASK_DETAILS_SUCCESS,
    FETCH_TASK_DETAILS_ERROR,
    CANCEL_TASK,
    CANCEL_TASK_SUCCESS,
    CANCEL_TASK_ERROR,

    REQUEST_MORE_QUOTATION,
    REQUEST_MORE_QUOTATION_SUCCESS,
    REQUEST_MORE_QUOTATION_FAIL,

    ADD_PAYMENT_DETAILS,
    ADD_PAYMENT_DETAILS_SUCCESS,
    ADD_PAYMENT_DETAILS_ERROR,

    SELECT_QUOTATION,
    SELECT_QUOTATION_SUCCESS,
    SELECT_QUOTATION_FAIL,

    FETCH_INSPECTORS,
    FETCH_INSPECTORS_SUCCESS,
    FETCH_INSPECTORS_ERROR,

    TASK_NOTICE_SEEN_SUCCESS,

    UPDATING_RATING_REVIEW,
    UPDATING_RATING_REVIEW_SUCCESS,
    UPDATING_RATING_REVIEW_FAIL,

    UPDATE_TASK,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_ERROR,

    CONFIG_TASK_DETAILS
} from '../actions/types'

import { QUICK_TASK, QUOTE_AFTER_INSPECTION, QUOTE_WITHOUT_INSPECTION } from '../constants/taskTypes'
import {
    PENDING,
    PREPARING,
    ASSIGNING_INSPECTOR,
    WAITING_FOR_QUOTES,
    WAITING_QUOTE_ACCEPTANCE,
    REQUESTING_QUOTES,
    ADVANCE_PAYMENT,
    WORKING,
    COMPLETED,
    PAID,
    CANCEL_TASK_BY_CLIENT,
    REJECTED
} from './../constants/taskStates'
import { formatMoney } from '../utils/commonUtil'

// When the backend has issued an invoice for the task, mention it in the status bar
const invoiceStatusText = (task, defaultText, intro) => {
    const latestInvoice = _.get(task, 'latestInvoice', null)
    if (_.isEmpty(latestInvoice) || !latestInvoice.invoiceNumber) {
        return defaultText
    }
    return `${intro} Invoice ${latestInvoice.invoiceNumber} — amount due ${formatMoney(latestInvoice.amountDue)} — has been emailed to you. Please settle the payment and submit the payment details`
}

const PAYMENT_RECEIVED_TEXT = "We've received your payment acknowledgement. We will verify it and notify you soon"

const configureTaskDetails = (dispatch, configs) => {
    dispatch({ type: CONFIG_TASK_DETAILS, payload: configs })
}

const configureAdditionalDetails = (dispatch, task) => {
    const { taskType, state, isRequestedMoreQuotes, quoteRequestCount } = task;
    let taskId = task._id

    // depend on state, taskType
    switch (taskType) {
        case QUICK_TASK:
            switch (state) {
                case PENDING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are now reviewing your task, you will be notified once we accept or reject',
                        showCancelTaskBtn: true,
                        showEditTaskButton: true
                    })
                    break
                case PREPARING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'Your task was approved! we are now assigning a service provider for your task'
                    })
                    break
                case WORKING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'A service provider was assigned to the task, will arrive within 24 hours'
                    })
                    break
                case COMPLETED:
                    configureTaskDetails(dispatch, {
                        showAddPaymentDetailsBtn: true,
                        statusBarText: _.isEmpty(task.finalPayment) ? invoiceStatusText(task, "Your task is now completed! Please settle the payment and submit the payment details", 'Your task is completed.') : PAYMENT_RECEIVED_TEXT,
                    })
                    break
                case PAID:
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was completed successfully and all payments were settled ${task.rating ? '' : '. Please give a feedback on this'}`,
                        showRatingAndReviews: true
                    })
                    break
                case CANCEL_TASK_BY_CLIENT:
                    configureTaskDetails(dispatch, {
                        statusBarText: `You cancelled this task for the reason, ${task.cancelReason}`
                    })
                    break
                case REJECTED:
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was rejected. ${task.rejectReason}`
                    })
                    break
                default:
                    break
            }
            break
        case QUOTE_AFTER_INSPECTION:
            switch (state) {
                case PENDING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are now reviewing your task, you will be notified once we accept or reject',
                        showCancelTaskBtn: true,
                        showEditTaskButton: true
                    })
                    break
                case ASSIGNING_INSPECTOR:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are assigning inspectors for the task',
                    })
                    break
                case WAITING_FOR_QUOTES:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We will send you quotations within 24 hours after inspection'
                    })
                    break
                case WAITING_QUOTE_ACCEPTANCE:
                    let requestedQuoteCountText = ''
                    if (quoteRequestCount) {
                        requestedQuoteCountText = `. You have requested ${quoteRequestCount} extra ${quoteRequestCount === 1 ? 'quote' : 'quotes'} so far`
                    }
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: `${isRequestedMoreQuotes ? 'You have requested an extra quote. You can select a quote once we send an extra quote' : 'Please select a quote. If you want more quotes, press the Request more Quotes button'} ${requestedQuoteCountText}`,
                        showRequestMoreQuotesBtn: true,
                        showScrollToQuotationsBtn: true
                    })
                    break
                case ADVANCE_PAYMENT:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: _.isEmpty(task.advancePayment) ? invoiceStatusText(task, 'Please do the advance payment and submit the payment details', 'Your quotation was accepted.') : PAYMENT_RECEIVED_TEXT,
                        showAddPaymentDetailsBtn: true
                    })
                    break
                case WORKING:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are working on your task'
                    })
                    break
                case COMPLETED:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: _.isEmpty(task.finalPayment) ? invoiceStatusText(task, 'We have completed your task. Please do the balance payment and submit the payment details', 'Your task is completed.') : PAYMENT_RECEIVED_TEXT,
                        showAddPaymentDetailsBtn: true
                    })
                    break
                case PAID:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was completed successfully and all payments were settled ${task.rating ? '' : '. Please give a feedback on this'}`,
                        showRatingAndReviews: true
                    })
                    break
                case REJECTED:
                    dispatch(fetchInspectors(taskId))
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was rejected for the reason, '${task.rejectReason}'`
                    })
                    break
                case CANCEL_TASK_BY_CLIENT:
                    configureTaskDetails(dispatch, {
                        statusBarText: `You cancelled this task for the reason, '${task.cancelReason}'`
                    })
                    break
                default:
                    break
            }
            break
        case QUOTE_WITHOUT_INSPECTION:
            switch (state) {
                case PENDING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are now reviewing your task, you will be notified once we accept or reject',
                        showCancelTaskBtn: true,
                        showEditTaskButton: true
                    })
                    break
                case REQUESTING_QUOTES:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We will send you quotations according to the provided details'
                    })
                    break
                case WAITING_FOR_QUOTES:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We will send you quotations according to the provided details'
                    })
                    break
                case WAITING_QUOTE_ACCEPTANCE:
                    let requestedQuoteCountText = ''
                    if (quoteRequestCount) {
                        requestedQuoteCountText = `. You have requested ${quoteRequestCount} extra ${quoteRequestCount === 1 ? 'quote' : 'quotes'} so far`
                    }
                    configureTaskDetails(dispatch, {
                        statusBarText: `${isRequestedMoreQuotes ? 'You have requested an extra quote. You can select a quote once we send an extra quote' : 'Please select a quote. If you want more quotes, press the Request more Quotes button'} ${requestedQuoteCountText}`,
                        showRequestMoreQuotesBtn: true,
                        showScrollToQuotationsBtn: true
                    })
                    break
                case ADVANCE_PAYMENT:
                    configureTaskDetails(dispatch, {
                        statusBarText: _.isEmpty(task.advancePayment) ? invoiceStatusText(task, 'Please do the advance payment and submit the payment details', 'Your quotation was accepted.') : PAYMENT_RECEIVED_TEXT,
                        showAddPaymentDetailsBtn: true
                    })
                    break
                case WORKING:
                    configureTaskDetails(dispatch, {
                        statusBarText: 'We are working on your task'
                    })
                    break
                case COMPLETED:
                    configureTaskDetails(dispatch, {
                        statusBarText: _.isEmpty(task.finalPayment) ? invoiceStatusText(task, 'We have completed your task. Please do the balance payment and submit the payment details', 'Your task is completed.') : PAYMENT_RECEIVED_TEXT,
                        showAddPaymentDetailsBtn: true
                    })
                    break
                case PAID:
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was completed successfully and all payments were settled ${task.rating ? '' : '. Please give a feedback on this'}`,
                        showRatingAndReviews: true
                    })
                    break
                case REJECTED:
                    configureTaskDetails(dispatch, {
                        statusBarText: `Your task was rejected for the reason, '${task.rejectReason}'`
                    })
                    break
                case CANCEL_TASK_BY_CLIENT:
                    configureTaskDetails(dispatch, {
                        statusBarText: `You cancelled this task for the reason, '${task.cancelReason}'`
                    })
                    break
                default:
                    break
            }
        default:
            break
    }
}

export const getTaskById = (taskId) => {
    return async (dispatch) => {

        dispatch({ type: FETCH_TASK_DETAILS });

        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };

        try {
            const response = await API.get('TasksAPI', `/tasks/${taskId}`, config);
            if (response.success) {
                dispatch({ type: FETCH_TASK_DETAILS_SUCCESS, payload: { task: response.task } })
                configureAdditionalDetails(dispatch, response.task)
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in fetching task details: ', error)
            dispatch({ type: FETCH_TASK_DETAILS_ERROR })
        }
    }
}

export const cancelTask = (taskId, reason, callBackAction = () => { }) => {
    return async (dispatch) => {

        dispatch({ type: CANCEL_TASK })

        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            },
            body: { cancelReason: reason }
        };

        try {
            const response = await API.del('TasksAPI', `/tasks/${taskId}`, config)
            if (response.success) {
                dispatch({ type: CANCEL_TASK_SUCCESS, payload: { reason, state: CANCEL_TASK_BY_CLIENT } })
                dispatch(showModal({ title: 'Success', body: 'Task cancelled successfully', isSuccess: true }))
                callBackAction()
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in caneling task: ', error)
            dispatch({ type: CANCEL_TASK_ERROR })
            dispatch(hideModal())
            dispatch(showModal({ title: 'Failed', body: 'Task cancel failed. Please try again later', isError: true }))
        }
    }
}

// Add payment details (Confirm payments)
export const addPaymentDetails = (paymentDetails, toggleModal) => {
    return async (dispatch) => {

        dispatch({ type: ADD_PAYMENT_DETAILS })

        try {
            let postData = {
                body: paymentDetails,
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.post('TasksAPI', `/payments`, postData)
            const success = _.get(response, 'success');

            if (success) {
                dispatch({ type: ADD_PAYMENT_DETAILS_SUCCESS, payload: { paymentDetails } })
                toggleModal()
                dispatch(showModal({ title: 'Success', body: 'Payment details submission success', isSuccess: true }))
            } else {
                throw new Error('Confirm payments failed')
            }
        } catch (error) {
            console.log('Error in payment confirmation: ', error)
            dispatch({ type: ADD_PAYMENT_DETAILS_ERROR })
            dispatch(showModal({ title: 'Failed', body: 'Payment confirmation failed. Please try again', isError: true }))
        }
    }
}

export const requestMoreQuotation = (taskId) => {
    return async (dispatch) => {
        dispatch({ type: REQUEST_MORE_QUOTATION })
        try {
            let config = {
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            }
            const response = await API.put('TasksAPI', `/tasks/${taskId}/quotation/request-new`, config)
            if (response.success) {
                dispatch({ type: REQUEST_MORE_QUOTATION_SUCCESS, payload: { quoteRequestCount: response.quoteRequestCount } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in requesting new quotation: ', error)
            dispatch({ type: REQUEST_MORE_QUOTATION_FAIL })
            dispatch(hideModal())
            dispatch(showModal({ title: 'Failed', body: 'Error in requesting an extra quotation. Please try again', isError: true, duration: 0 }))
        }
    }
}

export const selectQuotation = (taskId, quoteId, companyId) => {
    return async (dispatch) => {
        dispatch({ type: SELECT_QUOTATION })
        try {
            let postData = {
                body: { companyId },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.post('TasksAPI', `/tasks/${taskId}/quotation/${quoteId}`, postData)
            console.log("REsponse---------------->:", response)
            const result = _.get(response, "result", {})
            const success = _.get(response, 'success');
            const taskLeader = _.get(result, 'taskLeader', {});
            if (success) {
                dispatch(hideModal())
                dispatch({ type: SELECT_QUOTATION_SUCCESS, payload: { quoteId, taskLeader } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in selecting quotation', error)
            dispatch({ type: SELECT_QUOTATION_FAIL })
            dispatch(hideModal())
            dispatch(showModal({ title: 'Failed', body: 'Error in accepting quotation. Please try again', isError: true, duration: 0 }))
        }
    }
}


export const readSpecialNotice = (taskId, noticeId) => {
    return async (dispatch) => {

        try {
            let postData = {
                body: { taskId, noticeId },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.post('TasksAPI', `/notice`, postData)
            const success = _.get(response, 'success');

            if (success) {
                dispatch({ type: TASK_NOTICE_SEEN_SUCCESS, payload: { id: noticeId } })
            } else {
                throw new Error('Set notice seen failed')
            }
        } catch (error) {
            console.log('Set notice seen failed: ', error)
        }

    }
}

export const getTaskTypeText = (taskType) => {
    switch (taskType) {
        case QUICK_TASK:
            return ("Quick");
            break;
        case QUOTE_AFTER_INSPECTION:
            return ("Inspection");
            break;
        case QUOTE_WITHOUT_INSPECTION:
            return ("Non inspection");
            break;
        default:
            return ("")
    }
}

export const fetchInspectors = (taskId) => {
    return async (dispatch) => {

        dispatch({ type: FETCH_INSPECTORS });

        let config = {
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };

        try {
            const response = await API.get('TasksAPI', `/tasks/${taskId}/inspectors`, config);
            if (response.success) {
                dispatch({ type: FETCH_INSPECTORS_SUCCESS, payload: { inspectors: response.inspectors } })
            } else {
                throw new Error("Internal server error")
            }
        } catch (error) {
            console.log('Error in fetching inspectors: ', error)
            dispatch({ type: FETCH_INSPECTORS_ERROR })
        }
    }
}

export const updateRatingReviews = (rating, review, taskId, closeModal = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATING_RATING_REVIEW });

        try {
            let postData = {
                body: { rating, review },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.post('TasksAPI', `/tasks/${taskId}/review`, postData)
            const success = _.get(response, 'success');

            if (success) {
                dispatch({ type: UPDATING_RATING_REVIEW_SUCCESS, payload: { rating, review } });
                closeModal()
                dispatch(showModal({ title: 'Success', body: 'Feedback success', isSuccess: true }))
            } else {
                throw new Error('Feedback failed')
            }
        } catch (error) {
            console.log('Error in posting task: ', error)
            dispatch({ type: UPDATING_RATING_REVIEW_FAIL });
            dispatch(showModal({ title: 'Failed', body: 'Failed to give feedback. Please try again', isError: true }))
        }
    }
}


export const updateTaskRead = async (isRead, taskId) => {
    try {
        let postData = {
            body: { isRead },
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };

        const response = await API.post('TasksAPI', `/tasks/${taskId}/changeLances`, postData)
        const success = _.get(response, 'success');

        if (success) {
            console.log("upadating lance changing is success!")
        } else {
            throw new Error('Lance changing failed')
        }
    } catch (error) {
        console.log('Error in updating lance changing: ', error)
    }
}

export const updateTask = (taskId, updatedData, history, imageUploader) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_TASK })

        try {

            updatedData.images = await imageUploader.getImageUrls();

            let postData = {
                body: { updatedData },
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };

            const response = await API.put('TasksAPI', `/tasks/${taskId}`, postData)
            console.log("Response", response)
            const success = _.get(response, 'success');

            if (success) {
                dispatch({ type: UPDATE_TASK_SUCCESS, payload: { ...updatedData } })
                dispatch(showModal({ title: 'Success', body: 'Task updated successfully', isSuccess: true }))
                history.push(`/tasks/${taskId}`)
            } else {
                throw new Error('Update task failed')
            }
        } catch (error) {
            console.log('Update task failed: ', error)
            dispatch({ type: UPDATE_TASK_ERROR })
            dispatch(showModal({ title: 'Failed', body: 'Failed to update task. Please try again', isError: true }))
        }

    }
}

export const getTaskStateText = (taskState) => {
    switch (taskState) {
        case PENDING:
            return ("In Review");
        case PREPARING:
        case ASSIGNING_INSPECTOR:
        case WAITING_FOR_QUOTES:
        case WAITING_QUOTE_ACCEPTANCE:
        case REQUESTING_QUOTES:
            return ("Preparing");
        case ADVANCE_PAYMENT:
            return ("Advance Payment");
        case WORKING:
            return ("Working");
        case COMPLETED:
            return ("Completed");
        case PAID:
            return ("All Payments settled");
        case CANCEL_TASK_BY_CLIENT:
            return ("Cancelled");
        case REJECTED:
            return ("Rejected");
        default:
            return ("")
    }
}